import { createReducer } from '@ngrx/store';

import { INITIAL_MANAGE_SURVEY_STATE } from './manage-survey.model';
import { CORE_SURVEY_HANDLERS } from './manage-survey-core.handlers';
import { HEALTH_HANDLERS } from './manage-survey-health.handlers';
import { ACTIVITY_LOG_HANDLERS } from './manage-survey-activity-log.handlers';
import { COMMENTS_HANDLERS } from './manage-survey-comments.handlers';
import { QUOTA_HANDLERS } from './manage-survey-quota.handlers';
import { TRAFFIC_CHANNEL_HANDLERS } from './manage-survey-traffic-channel.handlers';
import { OPERATOR_TOOLS_HANDLERS } from './manage-survey-operator-tools.handlers';

// Handler groups live in sibling `manage-survey-*.handlers.ts` files, split by
// concern purely to keep each file a manageable size — this is still the one
// reducer for the one ManageSurveyState, just composed from smaller pieces.
export const manageSurveyReducer = createReducer(
  INITIAL_MANAGE_SURVEY_STATE,
  ...CORE_SURVEY_HANDLERS,
  ...HEALTH_HANDLERS,
  ...ACTIVITY_LOG_HANDLERS,
  ...COMMENTS_HANDLERS,
  ...QUOTA_HANDLERS,
  ...TRAFFIC_CHANNEL_HANDLERS,
  ...OPERATOR_TOOLS_HANDLERS,
);
